(function() {

    'use strict';

    angular.module('app').config(shipmentsUrlConfig);

    shipmentsUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function shipmentsUrlConfig ($routeProvider, $locationProvider) {
        $routeProvider.
        when('/shipments/view/:id', {
            templateUrl: '/templates/pages/shipments/view.html',
            controller: 'ShipmentsViewController',
            controllerAs: 'vm',
            params: {
                parent: 'shipments',
                subParent: 'shipmentSearch',
                customHeader: true,
                htmlTitle: 'Detailed Shipment View',
                pageTitle: 'Detailed Shipment View',
            }
        }).
        when('/shipments/archived/view/:id', {
            templateUrl: '/templates/pages/shipments/view.html',
            controller: 'ShipmentsViewController',
            controllerAs: 'vm',
            params: {
                parent: 'shipments',
                subParent: 'archivedShipments',
                customHeader: true,
                htmlTitle: 'Detailed Shipment View',
                pageTitle: 'Detailed Shipment View',
            }
        }).
        when('/shipments/tracking/', {
            templateUrl: '/templates/pages/shipments/tracking.html',
            controller: 'TrackingController',
            params: {
                parent: 'shipments',
                subParent: 'tracking',
                customHeader: true,
                htmlTitle: 'Shipment Tracking',
                pageTitle: 'Shipment Tracking',
            }
        }).
        when('/shipments/tracking/:id', {
            templateUrl: '/templates/pages/shipments/tracking.html',
            controller: 'TrackingController',
            params: {
                parent: 'shipments',
                subParent: 'tracking',
                customHeader: true,
                htmlTitle: 'Shipment Tracking',
                pageTitle: 'Shipment Tracking',
            }
        });
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/shipments.js